
<vee-navigation-header></vee-navigation-header>
<router-outlet></router-outlet>
@if (errorService.checkedBar) {
  <vee-error></vee-error>
}
<vee-cookie-banner-dialog></vee-cookie-banner-dialog>
<vee-language-select-dialog></vee-language-select-dialog>
<vee-alert-container></vee-alert-container>